"use strict";
/**
 * @file Created on Thu Aug 23 2018
 * @author VBr
 * @author Jaroslav Sevcik
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../../utils");

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");
/**
 * Validator that checks if a value is filled
 * some invalid values: null, false, undefined, empty string, string with only white-space characters
 */


var RequireValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(RequireValidator, _Validator_1$Validato);

  function RequireValidator() {
    _classCallCheck(this, RequireValidator);

    return _possibleConstructorReturn(this, _getPrototypeOf(RequireValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
  }

  _createClass(RequireValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      if (utils_1.Utils.isNumber(value) && value === 0) {
        return new ValidationResult_1.ValidationSuccess(value);
      }

      if (utils_1.Utils.isString(value) && !value.trim()) {
        return new ValidationResult_1.ValidationError(RequireValidator.NON_WHITE_SPACE_CHARACTER_REQUIRED);
      }

      if (!value) {
        return new ValidationResult_1.ValidationError(RequireValidator.REQUIRED_ERROR);
      }

      return new ValidationResult_1.ValidationSuccess(value);
    }
  }]);

  return RequireValidator;
}(Validator_1.Validator);

exports.RequireValidator = RequireValidator;
RequireValidator.REQUIRED_ERROR = 'REQUIRED';
RequireValidator.NON_WHITE_SPACE_CHARACTER_REQUIRED = 'NON_WHITE_SPACE_CHARACTER_REQUIRED';